<div class="card">
  <app-header
    [titulo]="isEditMode ? 'Editar Provedor' : 'Novo Provedor'"
    [descricao]="isEditMode ? 'Atualizar informações do provedor' : 'Criar novo provedor de dados (Banco de Dados ou API REST)'">
  </app-header>

  <form [formGroup]="form" (ngSubmit)="salvar()">

    <!-- Seção: Informações do Provedor -->
    <div class="p-fluid grid">
      <div class="col-12">
        <h5 class="section-title">Informações do Provedor</h5>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do Provedor *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres)
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="tipo"
            formControlName="tipo"
            [options]="tiposProvedor"
            optionLabel="label"
            optionValue="value"
            [style]="{'width':'100%'}"
            [class.ng-invalid]="campoInvalido('tipo')"
            [class.ng-dirty]="campoInvalido('tipo')"
          ></p-dropdown>
          <label for="tipo">Tipo de Provedor *</label>
        </p-floatLabel>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <textarea
            pInputTextarea
            id="descricao"
            formControlName="descricao"
            rows="3"
            [class.ng-invalid]="campoInvalido('descricao')"
            [class.ng-dirty]="campoInvalido('descricao')"
          ></textarea>
          <label for="descricao">Descrição *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('descricao')">
          Descrição é obrigatória
        </small>
      </div>
    </div>

    <hr class="form-divider">

    <!-- Seção: Configuração da Conexão -->
    <div class="p-fluid grid">
      <div class="col-12">
        <h5 class="section-title">Configuração da Conexão</h5>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="nomeConexao"
            formControlName="nomeConexao"
            [class.ng-invalid]="campoInvalido('nomeConexao')"
            [class.ng-dirty]="campoInvalido('nomeConexao')"
          />
          <label for="nomeConexao">Nome da Conexão *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nomeConexao')">
          Nome da conexão é obrigatório (mínimo 3 caracteres)
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="ambiente"
            formControlName="ambiente"
            placeholder="Ex: Produção, Desenvolvimento, Homologação"
            [class.ng-invalid]="campoInvalido('ambiente')"
            [class.ng-dirty]="campoInvalido('ambiente')"
          />
          <label for="ambiente">Ambiente *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('ambiente')">
          Ambiente é obrigatório
        </small>
      </div>

      <div class="field col-12 md:col-10">
        <div class="field-checkbox">
          <p-checkbox
            id="padrao"
            formControlName="padrao"
            [binary]="true"
          ></p-checkbox>
          <label for="padrao">Marcar como conexão padrão</label>
        </div>
      </div>
    </div>

    <!-- Campos específicos para API REST -->
    <div *ngIf="mostrarCampoApiRest()" class="p-fluid grid">
      <div class="col-12">
        <h6 class="subsection-title">Configuração de API REST</h6>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <input
            pInputText
            id="urlBase"
            formControlName="urlBase"
            placeholder="https://api.exemplo.com"
            [class.ng-invalid]="campoInvalido('urlBase')"
            [class.ng-dirty]="campoInvalido('urlBase')"
          />
          <label for="urlBase">URL Base da API *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('urlBase')">
          URL Base é obrigatória para API REST
        </small>
      </div>
    </div>

    <!-- Campos específicos para Banco de Dados -->
    <div *ngIf="mostrarCamposBancoDados()" class="p-fluid grid">
      <div class="col-12">
        <h6 class="subsection-title">Configuração de Banco de Dados</h6>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="tipo_bd"
            formControlName="tipo_bd"
            [options]="tiposBancoDados"
            optionLabel="label"
            optionValue="value"
            [style]="{'width':'100%'}"
            [class.ng-invalid]="campoInvalido('tipo_bd')"
            [class.ng-dirty]="campoInvalido('tipo_bd')"
          ></p-dropdown>
          <label for="tipo_bd">Tipo de Banco de Dados *</label>
        </p-floatLabel>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="host"
            formControlName="host"
            placeholder="localhost ou 192.168.1.100"
            [class.ng-invalid]="campoInvalido('host')"
            [class.ng-dirty]="campoInvalido('host')"
          />
          <label for="host">Host *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('host')">
          Host é obrigatório
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-inputNumber
            id="porta"
            formControlName="porta"
            [min]="1"
            [max]="65535"
            [useGrouping]="false"
            [class.ng-invalid]="campoInvalido('porta')"
            [class.ng-dirty]="campoInvalido('porta')"
          ></p-inputNumber>
          <label for="porta">Porta *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('porta')">
          Porta é obrigatória (1-65535)
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="database"
            formControlName="database"
            [class.ng-invalid]="campoInvalido('database')"
            [class.ng-dirty]="campoInvalido('database')"
          />
          <label for="database">Nome do Banco de Dados *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('database')">
          Nome do banco de dados é obrigatório
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <p-floatLabel>
          <p-inputNumber
            id="timeout"
            formControlName="timeout"
            suffix=" ms"
            [min]="1000"
            [max]="300000"
            [step]="1000"
          ></p-inputNumber>
          <label for="timeout">Timeout (ms)</label>
        </p-floatLabel>
        <small class="p-text-secondary">Padrão: 30000 ms (30 segundos)</small>
      </div>

      <div class="field col-12 md:col-4">
        <p-floatLabel>
          <p-inputNumber
            id="retry_tentativas"
            formControlName="retry_tentativas"
            [min]="0"
            [max]="10"
            [useGrouping]="false"
          ></p-inputNumber>
          <label for="retry_tentativas">Tentativas de Retry</label>
        </p-floatLabel>
        <small class="p-text-secondary">Padrão: 3 tentativas</small>
      </div>

      <div class="field col-12 md:col-4">
        <p-floatLabel>
          <p-inputNumber
            id="retry_intervalo"
            formControlName="retry_intervalo"
            suffix=" ms"
            [min]="100"
            [max]="10000"
            [step]="100"
          ></p-inputNumber>
          <label for="retry_intervalo">Intervalo entre Retries (ms)</label>
        </p-floatLabel>
        <small class="p-text-secondary">Padrão: 1000 ms (1 segundo)</small>
      </div>
    </div>

    <hr class="form-divider">

    <!-- Seção: Credenciais -->
    <div class="p-fluid grid">
      <div class="col-12">
        <h5 class="section-title">Credenciais de Acesso</h5>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="tipoCredencial"
            formControlName="tipoCredencial"
            [options]="tiposCredencial"
            optionLabel="label"
            optionValue="value"
            [style]="{'width':'100%'}"
          ></p-dropdown>
          <label for="tipoCredencial">Tipo de Credencial *</label>
        </p-floatLabel>
      </div>

      <!-- Credenciais: DATABASE -->
      <ng-container *ngIf="mostrarCredencialDatabase()">
        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="cred_user"
              formControlName="cred_user"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_user')"
              [class.ng-dirty]="campoInvalido('cred_user')"
            />
            <label for="cred_user">Usuário do Banco *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_user')">
            Usuário é obrigatório
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              type="password"
              id="cred_password_db"
              formControlName="cred_password"
              autocomplete="new-password"
              [class.ng-invalid]="campoInvalido('cred_password')"
              [class.ng-dirty]="campoInvalido('cred_password')"
            />
            <label for="cred_password_db">Senha do Banco *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_password')">
            Senha é obrigatória
          </small>
        </div>
      </ng-container>

      <!-- Credenciais: BASIC -->
      <ng-container *ngIf="mostrarCredencialBasic()">
        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="cred_username"
              formControlName="cred_username"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_username')"
              [class.ng-dirty]="campoInvalido('cred_username')"
            />
            <label for="cred_username">Username *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_username')">
            Username é obrigatório
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              type="password"
              id="cred_password_basic"
              formControlName="cred_password"
              autocomplete="new-password"
              [class.ng-invalid]="campoInvalido('cred_password')"
              [class.ng-dirty]="campoInvalido('cred_password')"
            />
            <label for="cred_password_basic">Password *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_password')">
            Password é obrigatório
          </small>
        </div>
      </ng-container>

      <!-- Credenciais: BEARER -->
      <ng-container *ngIf="mostrarCredencialBearer()">
        <div class="field col-12">
          <p-floatLabel>
            <textarea
              pInputTextarea
              id="cred_token"
              formControlName="cred_token"
              rows="3"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_token')"
              [class.ng-dirty]="campoInvalido('cred_token')"
            ></textarea>
            <label for="cred_token">Bearer Token *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_token')">
            Token é obrigatório
          </small>
        </div>
      </ng-container>

      <!-- Credenciais: API_KEY -->
      <ng-container *ngIf="mostrarCredencialApiKey()">
        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="cred_header"
              formControlName="cred_header"
              placeholder="X-API-Key"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_header')"
              [class.ng-dirty]="campoInvalido('cred_header')"
            />
            <label for="cred_header">Nome do Header *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_header')">
            Nome do header é obrigatório
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="cred_apiKey"
              formControlName="cred_apiKey"
              autocomplete="off"
              [class.ng-invalid]="campoInvalido('cred_apiKey')"
              [class.ng-dirty]="campoInvalido('cred_apiKey')"
            />
            <label for="cred_apiKey">API Key *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('cred_apiKey')">
            API Key é obrigatória
          </small>
        </div>
      </ng-container>

      <!-- Credenciais: OAUTH2 -->
      <ng-container *ngIf="mostrarCredencialOAuth2()">
        <div class="col-12">
          <div class="info-message">
            <i class="pi pi-info-circle"></i>
            Configuração OAuth2 deve ser realizada através de configurações avançadas no backend.
          </div>
        </div>
      </ng-container>

      <!-- Credenciais: SEM_CREDENCIAL -->
      <ng-container *ngIf="form.get('tipoCredencial')?.value === TipoCredencial.SEM_CREDENCIAL">
        <div class="col-12">
          <div class="info-message">
            <i class="pi pi-info-circle"></i>
            Nenhuma credencial será utilizada para esta conexão.
          </div>
        </div>
      </ng-container>
    </div>

    <hr class="form-divider">

    <!-- Botões de Ação -->
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()"
        [disabled]="loading"
      ></p-button>

      <p-button
        label="Limpar"
        icon="pi pi-times"
        severity="warning"
        (onClick)="limpar()"
        [disabled]="loading"
        *ngIf="!isEditMode"
      ></p-button>

      <p-button
        [label]="isEditMode ? 'Atualizar' : 'Salvar'"
        icon="pi pi-check"
        severity="success"
        type="submit"
        [loading]="loading"
      ></p-button>
    </div>
  </form>
</div>
